<template>
  <CContainer fluid>
    <h3>Productos</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:" 
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  class="text-dark" 
                  @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol>
            <CButton
              color="success"
              class="mt-4"
              :to="endpointAddProduct">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable
          hover
          :fields="fields"
          :items="products"
          :items-per-page="itemsPerPage">
          <template #avatar="{item}">
            <!-- <td :key="uuid.v1()" style="border-top: none;" v-on:click.stop.prevent="selectNewAvatar($event, item)"> -->
            <td :key="uuid.v1()">
              <div class="c-avatar c-avatar-stack c-avatar-xl">
                <img v-if="!item.url_Imagen" src="../../../../../public/static/imagen-no-disponible.gif" block class="c-avatar-img"/>
                <URLImg v-if="item.url_imagen" :url="item.url_imagen" block class="c-avatar-img"/>
                <UploadNewImgHiddenInput 
                  :api="uploadImg" 
                  :parentId="item.id_Producto" 
                  @handler="_function => setValueHandler(_function, item)"/>
              </div>
            </td>
          </template>
          <template #codigo="{item}">
            <td>
              <h4>{{ item.descripcion }}</h4>
              <span class="font-weight-bold">{{ item.codigo }}</span>
              &nbsp;
              <span v-if="item.barcode">{{ item.barcode }}</span>
              <div v-if="$store.state.user.data.tipo_Empleado === 'A'">
                <a href="#" 
                  @click="event => {
                    event.stopPropagation()
                    selectNewAvatar(event, item)
                  }">
                  <i class="bi bi-image h5"></i>
                </a>
                <a href="#"
                  class="ml-2"
                  v-c-tooltip="'Seriales'"
                  @click="openModalSeriales($event, item.id_Producto)">
                  <i class="bi bi-upc-scan text-dark h5"></i>
                </a>

              </div>
            </td>
          </template>
          <template #presentacion="{item}">
            <td class="d-flex flex-column">
              <span v-if="item.presentacion">{{ item.presentacion }}</span>
              <span v-if="item.marca">{{ item.marca }}</span>
              <span v-if="item.categoria">{{ item.categoria }}</span>
            </td>
          </template>
          <template #valores="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>{{ item.tarifa_iva }}%</span>
                <i class="bi bi-info-circle ml-2"></i>
              </div>
              <div class="d-flex justify-content-end">
                <span v-if="item.costo_Promedio">$ {{ formatter.format(item.costo_Promedio) }}</span>
                <i class="bi bi-cash-coin ml-2"></i>
              </div>
              <div class="d-flex justify-content-end">
                <span>{{ formatter.format(item.unidades_disponibles ? item.unidades_disponibles : 0, 0) }}</span>
                <i class="bi bi-box-seam ml-2"></i>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#"
                style="text-decoration: none;"
                class="mb-2 p-2"
                v-on:click.stop.prevent="toggleDocument($event, item)">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
              </a>
            </td>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />        
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>

    <right-side-bar :size="'xl'" :show="showPanelSerial" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-4">
          <CCardHeader>
            <h4 class="mt-1">Seriales del Producto</h4>
          </CCardHeader>
          <CCardBody>
            <serials-product :idProduct="idProduct" :key="updateComponent" />
          </CCardBody>
        </CCard>
        <div class="d-flex justify-content-center">
          <CButton 
            color="primary"
            @click="showPanelSerial=false">
            <span class="align-middle">Cerrar</span>
          </CButton>
        </div>
      </CContainer>
    </right-side-bar>

  </CContainer>
</template>
<script>
  import { ref } from "vue";
  import { uuid } from 'vue-uuid'
  import { DATAGRID_PRODUCTOS } from "@/helpers/moduleNames";
  import constants from "@/constants";
  import { 
    formatter,
    errorMessage
  } from "@/general";
  import { dataGridProductos } from "@/apis/products";
  import { grabaImagenProducto } from "@/api";
  
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import RightSideBar from "@/components/containers/RightSideBar.vue"
  import URLImg from '@/components/containers/URLImg.vue'
  import UploadNewImgHiddenInput from '@/components/containers/UploadNewImgHiddenInput.vue'
  import SerialsProduct from "@/components//datagrids/ProductSerials.vue"

  const fields = [
    {
      key: 'avatar',
      label: ''
    },
    { 
      key: 'codigo', 
      label: 'Producto', 
      _style:'text-align:center;'
    },
    { 
      key: 'presentacion', 
      label: 'Clasificación', 
      _style:'text-align:center;'
    },
    { 
      key: 'valores',
      label: 'Valores',
      _style:'text-align:center;'
    }
    // {
    //   key: 'info',
    //   label: "",
    //   _style:'text-align:center;'
    // }
  ]

  export default {
    name: 'ProductsEmployee',
    components: {
      LoadingCover,
      RightSideBar,
      URLImg,
      UploadNewImgHiddenInput,
      SerialsProduct
    },
    constants: {
      DATAGRID_PRODUCTOS
    },
    data(){
      return {
        formatter,
        uuid,
        loading: false,
        showPanelSerial: null,
        updateComponent: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        fields,
        products: [],
        idProduct: ""
      }
    },
    methods: {
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        if (page !== this.page) {
          this.page = page
        }

        try {
          const { count, results } = await dataGridProductos(this, page, search);

          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          } 
          
          this.products = results
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
                message: 'Error al cargar datos',
                show: 5
            })
        } finally{
          this.loading = false
        }
      },
      async uploadImg(productId, fileName, base64) {
        try {
          this.loading = true

          await grabaImagenProducto(
            this,
            productId,
            fileName,
            base64
          )
          this.$store.commit(
            'setAlert',
            { 
              color: 'success',
              message: constants.messages.successfulAction,
              show: 5 
            }
          )
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
              message: errorMessage(error),
              show: 5
          })
        } finally {
          this.loading = false
          await this.getData(this.page, this.searchWord)
        }
      },
      openModalSeriales(e, idProduct) {
        e.stopPropagation

        this.showPanelSerial = true
        this.idProduct = idProduct
        this.updateComponent += 1

        console.log(idProduct);
      },
      toggleDocument(e, item){
        e.stopPropagation()
        this.$set(item, '_toggled', !item._toggled)
        // this.$nextTick(() => { })
      },
      selectNewAvatar(e, item) {
        e.stopPropagation()
        // this.$set(item, '_open', !item._open)
        // this.$nextTick(() => { })
        item._open()
      },
      setValueHandler(_function, item) {
        // console.log("Entra a setValueHandler de productos...");
        this.$set(item, '_open', _function)
        // this.$nextTick(() => { })
      }
    },
    setup() {
      const rootPath = ref("");
      const endpointAddProduct = ref("");

      return {
        rootPath,
        endpointAddProduct
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.endpointAddProduct = `${this.rootPath}/agregar`;

      console.info("Store ", this.$store.state.user);

      DATAGRID_PRODUCTOS["route"] = this.$router.currentRoute.fullPath;

      await this.$store.dispatch("registerApplicationModule", DATAGRID_PRODUCTOS);

      // try {
      //   const data = {
      //     "modulo": DATAGRID_PRODUCTOS.module,
      //     "descripcion": DATAGRID_PRODUCTOS.description,
      //     "ruta_Modulo": this.$router.currentRoute.fullPath
      //   }
      //   crudModuloAplicacion(this, "create", null, data);
      // } catch (error) {
      //   this.$store.commit("setAlert", {
      //     color: "danger",
      //     message: error,
      //     show: 5
      //   });
      // }

      await this.getData(this.page);
    }
  }
</script>